{
  "resourceType": "CodeSystem",
  "status": "draft",
  "content": "complete",
  "name": "ProcedurePerformerRole",
  "id": "procedure-performer-role",
  "title": "Panel Health Procedure Performer Role",
  "description": "Roles Panel Health records for extracted procedure performers.",
  "version": "0.0.1",
  "url": "https://casetech.app/fhir/CodeSystem/procedure-performer-role",
  "concept": [
    {
      "code": "attending",
      "display": "Attending"
    },
    {
      "code": "resident",
      "display": "Resident"
    },
    {
      "code": "midlevel-assistant",
      "display": "Midlevel assistant"
    },
    {
      "code": "nonresident-assistant",
      "display": "Nonresident assistant"
    }
  ],
  "count": 4
}
